import type { ComponentProps, ReactNode } from "react";

import { Button, type ButtonProps } from "simplydo/react/ui/button";
import { Popup } from "simplydo/react/ui/popup";

type TooltipButtonProps = ButtonProps & {
  tooltip?: ReactNode;
  tooltipProps?: ComponentProps<typeof Popup>;
};

const TooltipButton = ({
  tooltip,
  tooltipProps = {},
  ...props
}: TooltipButtonProps) => {
  if (!tooltip) {
    return <Button {...props} />;
  }
  return (
    <Popup {...tooltipProps} trigger={<Button {...props} />}>
      {tooltip}
    </Popup>
  );
};

export default TooltipButton;
